import React from 'react';
export function UrgencyBar() {
  return <div className="bg-[#C6F432] text-[#0A1628] text-center py-2 px-4 font-bold text-sm md:text-base uppercase tracking-wider sticky top-0 z-50 shadow-md" data-id="element-370">
      🎾 OFERTA DE LANZAMIENTO — BONOS GRATIS POR HOY
    </div>;
}